import { Suspense } from 'react';
import { Box, Loader, Center, Alert } from '@mantine/core';
import { Widget, GroupId } from '@pulse-ui/widget-sdk';
import { ErrorBoundary } from 'react-error-boundary';

interface WidgetContainerProps {
  widgetId: string;
  instanceId: string;
  WidgetComponent: Widget;
  config?: Record<string, unknown>;
  groupId?: GroupId;
}

/**
 * Container for individual widget instances
 * Handles lazy loading, error boundaries, and suspense
 */
export function WidgetContainer({
  widgetId,
  instanceId,
  WidgetComponent,
  config,
  groupId,
}: WidgetContainerProps) {
  return (
    <Box h="100%" w="100%">
      <ErrorBoundary
        fallback={
          <Center h="100%">
            <Alert color="red" title="Widget Error">
              Failed to load widget: {widgetId}
            </Alert>
          </Center>
        }
      >
        <Suspense
          fallback={
            <Center h="100%">
              <Loader size="sm" />
            </Center>
          }
        >
          <WidgetComponent
            instanceId={instanceId}
            groupId={groupId}
            config={config}
          />
        </Suspense>
      </ErrorBoundary>
    </Box>
  );
}
